An array of formatted position profile descriptions.
